(() => {
  const FORM_SELECTOR = 'form[data-newsletter-provider="klaviyo"]';
  const REVISION = '2023-06-15';
  const FALLBACK_ERROR = 'There was a problem subscribing. Please try again.';

  function hideMessages(form) {
    const success = form.querySelector('[data-newsletter-success]');
    const error = form.querySelector('[data-newsletter-error]');

    if (success) success.hidden = true;
    if (error) error.hidden = true;
  }

  function showSuccess(form) {
    const success = form.querySelector('[data-newsletter-success]');

    if (success) success.hidden = false;
  }

  function showError(form, message) {
    const error = form.querySelector('[data-newsletter-error]');
    const errorMessage = form.querySelector('[data-newsletter-error-message]');

    if (errorMessage) {
      errorMessage.textContent = message || FALLBACK_ERROR;
    }

    if (error) error.hidden = false;
  }

  async function parseError(response) {
    const responseText = await response.text();

    if (!responseText) {
      return FALLBACK_ERROR;
    }

    try {
      const data = JSON.parse(responseText);
      if (Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors
          .map((error) => error.detail || error.title)
          .filter(Boolean)
          .join(' ');
      }
    } catch (error) {
      return responseText;
    }

    return FALLBACK_ERROR;
  }

  async function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const emailInput = form.querySelector('input[type="email"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const publicApiKey = form.dataset.klaviyoPublicApiKey;
    const listId = form.dataset.klaviyoListId;
    const customSource = form.dataset.klaviyoCustomSource || 'Footer Newsletter';
    const email = emailInput ? emailInput.value.trim() : '';

    hideMessages(form);

    if (!emailInput || !publicApiKey || !listId) {
      showError(form, FALLBACK_ERROR);
      return;
    }

    if (!form.checkValidity()) {
      const invalidField = form.querySelector(':invalid');

      form.reportValidity();
      showError(form, invalidField?.validationMessage || 'Please complete the required fields.');
      return;
    }

    submitButton?.setAttribute('disabled', 'disabled');
    form.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicApiKey)}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: REVISION,
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                list_id: listId,
                custom_source: customSource,
                email,
              },
            },
          }),
        }
      );

      if (!response.ok) {
        throw new Error(await parseError(response));
      }

      form.reset();
      showSuccess(form);
    } catch (error) {
      showError(form, error.message || FALLBACK_ERROR);
    } finally {
      submitButton?.removeAttribute('disabled');
      form.removeAttribute('aria-busy');
    }
  }

  function initKlaviyoNewsletterForms(root = document) {
    root.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      if (form.dataset.klaviyoBound === 'true') return;

      form.dataset.klaviyoBound = 'true';
      form.addEventListener('submit', handleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initKlaviyoNewsletterForms());
  } else {
    initKlaviyoNewsletterForms();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initKlaviyoNewsletterForms(event.target);
  });
})();
